import { annualReportDisclaimer1, annualReportDisclaimer2, mayBeContactedAgreementText } from "../PurchaseConstants"

export const FloridaAnnualReportTerms = (props: {
    annualPhrasing: string
}) => {
    const { annualPhrasing } = props;
    return (
        <>
            I hereby certify that the information supplied with this filing does not qualify for the public records exemptions contained in Chapter 119, Florida Statutes.
            <br /><br />
            I hereby certify that the information indicated on this report or
            supplemental report is true and accurate and that my electronic signature
            shall have the same legal effect as if made under oath; that I am authorized to
            execute this report as required by Chapter 605, Florida Statutes; I am aware that
            false information submitted in a document to the Department of State constitutes a
            third degree felony as provided for in s.
            &nbsp;
            <a className="link-text" target="_blank" rel="noreferrer" href="http://www.leg.state.fl.us/statutes/index.cfm?App_mode=Display_Statute&Search_String=&URL=0800-0899/0817/Sections/0817.155.html">
                817.155
            </a>
            &nbsp;, F.S.
            <br /><br />
            This signature must be that of the individual "signing" this document electronically or be made with the full knowledge and permission of the individual, otherwise it constitutes forgery under s. 831.06 , F.S. The individual "signing" this document affirms that the facts stated herein are true.
            <br /><br />
            {mayBeContactedAgreementText}
            <br /><br />
            With my digital signature, (i) I represent and warrant that all of the information provided above is accurate and complete; (ii) I agree that I have carefully read and agree to be bound by the Terms of Service, Refund Policy, and Privacy Policy (see below) and (iii) I have read and understand that I am hereby authorizing Florida Business Filing Center as a "Third Party Designee" to file my {annualPhrasing} on my behalf using the information I provided.
        </>
    )
}

export const GeorgiaAnnualReportTerms = () => {
    return (
        <>
            {mayBeContactedAgreementText}
            <br /><br />
            {annualReportDisclaimer1}
            <br /><br />
            {annualReportDisclaimer2}
        </>
    )
}

export const IndianaAnnualReportTerms = () => {
    return (
        <>
            {mayBeContactedAgreementText}
            <br /><br />
            With my digital signature, (i) I represent and warrant that all of the information provided above is accurate and complete; (ii) I agree that I have carefully read and agree to be bound by the Terms of Service, Refund Policy, and Privacy Policy (see below) and (iii) I have read and understand that I am hereby authorizing Indiana Business Filing Center as a "Third Party Designee", to answer any questions on my behalf or the behalf of the entity listed above about the completion of this Business Entity Report, and to receive and deliver to me the Business Entity Report for me or the entity listed above.
            <br /><br />
            {`In Witness Whereof, the undersigned hereby verifies, subject to the penalties of perjury, that the statements contained herein are true, this day, ${new Date().toLocaleDateString()}`}
            <br /><br />
            The undersigned acknowledges that a person commits a Class A misdemeanor by signing a document that the person knows is false in a material respect with the intent that the document be delivered to the Secretary of State for filing.
        </>
    )
}

export const MississippiAnnualReportTerms = () => {
    return (
        <>
            {mayBeContactedAgreementText}
            <br /><br />
            With my digital signature, (i) I represent and warrant that all of the information provided above is accurate and complete; (ii) I agree that I have carefully read and agree to be bound by the Terms of Service, Refund Policy, and Privacy Policy (see below) and (iii) I have read and understand that I am hereby authorizing Mississippi Business Filing Center as a "Third Party Designee", to answer any questions on my behalf or the behalf of the entity listed above about the completion of this Annual Report, and to receive and deliver to me the Annual Report for me or the entity listed above.
            <br /><br />
            {`The undersigned, by typing my name in the box below, certifies that I am authorized to file this document on behalf of this entity, has examined the document and, to the best of my knowledge and belief, it is true, correct and complete as of this day ${new Date().toLocaleDateString()}`}
        </>
    )
}

export const MontanaAnnualReportTerms = () => {
    return (
        <>
            {mayBeContactedAgreementText}
            <br /><br />
            {annualReportDisclaimer1}
            <br /><br />
            I understand that the information I enter into the online system is public information and will appear online and on copy requests exactly as I key it into the system.
            <br /><br />
            I have been authorized by the business entity to file this document online.
            <br /><br />
            I, HEREBY SWEAR AND/OR AFFIRM, under penalty of law, including criminal prosecution, that the facts contained in this document are true. I certify that I am signing this document as the person(s) whose signature is required, or as an agent of the person(s) whose signature is required, who has authorized me to place his/her signature on this document.
        </>
    )
}

export const NorthCarolinaAnnualReportTerms = () => {
    return (
        <>
            {mayBeContactedAgreementText}
            <br /><br />
            {annualReportDisclaimer1}
            <br /><br />
            The above company is the entity I intend to file an annual report for. I am authorized to file an annual report for the above company.
        </>
    )
}

export const TennesseeAnnualReportTerms = () => {
    return (
        <>
            {mayBeContactedAgreementText}
            <br /><br />
            With my digital signature, (i) I represent and warrant that all of the information provided above is accurate and complete; (ii) I agree that I have carefully read and agree to be bound by the Terms of Service, Refund Policy, and Privacy Policy (see below) and (iii) I have read and understand that I am hereby authorizing Tennessee Business Filing Center as a "Third Party Designee" to renew my business on my behalf using the information I provided.
            <br /><br />
            By checking the box below, you certify the following: <br />
            <ul style={{ margin: '10px 0' }}>
                <li>
                    I understand that the information submitted electronically by me will be used to generate an annual report for this company that will be filed with the Secretary of State;
                </li>
                <li>
                    I am authorized to submit an annual report for this company;
                </li>
                <li>
                    I intend and agree that the electronic submission of the information set forth herein constitutes my signature of the annual report;
                </li>
                <li>
                    The information is correct; and
                </li>
                <li>
                    I understand that the submission of fraudulent information may subject the company to administrative dissolution/revocation proceedings and may also subject me to criminal prosecution.
                </li>
            </ul>
        </>
    )
}

export const VirginiaAnnualReportTerms = () => {
    return (
        <>
            {mayBeContactedAgreementText}
            <br /><br />
            With my digital signature, (i) I represent and warrant that all of the information provided above is accurate and complete; (ii) I agree that I have carefully read and agree to be bound by the Terms of Service, Refund Policy, and Privacy Policy (see below) and (iii) I have read and understand that I am hereby authorizing Virginia Business Filing Center as a "Third Party Designee" to renew my business on my behalf using the information I provided.
            <br /><br />
            I affirm that the information contained in this electronic submission is accurate and complete and that I am legally authorized to sign the document. I acknowledges that it is unlawful to sign a document that is false in any material respect with the intent that it be delivered to the Commission for filing. I affirm that the information contained in this report is accurate and complete as of the date of this filing and that the person signing is authorized to sign the annual report.
        </>
    )
}

export const StateSpecificAnnualTerms = (props: { state: string }) => {
    const { state } = props;

    switch (state) {
        case "Florida":
            return <FloridaAnnualReportTerms annualPhrasing={"annual report"} />;
        case "Georgia":
            return <GeorgiaAnnualReportTerms />;
        case "Indiana":
            return <IndianaAnnualReportTerms />;
        case "Mississippi":
            return <MississippiAnnualReportTerms />;
        case "Montana":
            return <MontanaAnnualReportTerms />;
        case "North Carolina":
            return <NorthCarolinaAnnualReportTerms />;
        case "Tennessee":
            return <TennesseeAnnualReportTerms />;
        case "Virginia":
            return <VirginiaAnnualReportTerms />;
        default:
            return null;
    }
}